export default __webpack_public_path__ + "static/media/pvilla3-1.cbd3eb7f.jpg";